import axios from "axios";
import * as ROUTES from "../constants/route";
import { Cookies } from "react-cookie";

export const BOOKING_LIMITS_ERROR =
  "We couldn't confirm your investment allowance. Please retry before investing.";

export const BOOKING_REJECTION_MESSAGES = {
  "uitf-tier3-required": "UITFs require Tier 3 verification. Get fully verified before investing in this fund.",
  "fund-classification-required": "This fund's classification is unavailable. Please contact Rampver before investing.",
  "tier2-limit-exceeded": "This amount exceeds your remaining Tier 2 investment allowance. Review your updated allowance and try again.",
};

export const getBookingRejectionMessage = (body) =>
  BOOKING_REJECTION_MESSAGES[body?.code] || "";

export const getBookingLimits = async () => {
  const response = await axios.get(
    `${ROUTES.FUNCTION_BASE_URL}v2/investments/booking-limits`,
    { headers: { Authorization: `Bearer ${new Cookies().get("token") || ""}` } }
  );
  const { ok, data } = response.data || {};
  const amounts = [data?.cap, data?.netApprovedAmount, data?.pendingAmount, data?.remainingAmount];
  if (ok !== true || ![2, 3].includes(data?.tier) ||
      amounts.some((value) => !Number.isFinite(value) || value < 0) ||
      data.cap !== (data.tier === 2 ? 50000 : 100000000) || data.remainingAmount > data.cap) {
    throw new Error(BOOKING_LIMITS_ERROR);
  }
  return data;
};
